export let config = {
    apiKey: "AIzaSyCMu6tZ0Jiu9vGWPTE9F3izgGZBVQVXwZg",
    authDomain: "scrummy-a1a60.firebaseapp.com",
    databaseURL: "https://scrummy-a1a60.firebaseio.com",
    projectId: "scrummy-a1a60",
    storageBucket: "scrummy-a1a60.appspot.com",
    messagingSenderId: "919357694563"
  };